import { api } from "@/builders/axios";
import { StaffListDataUpdate } from "@/builders/types/staff-list";

const get = function (variables: { staff_id: string; unique_link: string }) {
  const { staff_id, unique_link } = variables;
  return api
    .get<{
      data: {
        id: number;
        first_name: string;
        last_name: string;
        staff_id: string;
        user: {
          id: number;
          username: string;
          first_name: string;
          last_name: string;
        };
      };
    }>(`staffs/staff-id/${staff_id}/${unique_link}`)
    .then(({ data }) => data);
};

const put = function (variables: { id: number; data: StaffListDataUpdate }) {
  const { id, data } = variables;
  return api.put(`/staffs/${id}`, data).then(({ data }) => data);
};

const del = function (staff_id: number) {
  return api.delete(`/staffs/${staff_id}`);
};

export const id = {
  get,
  put,
  del,
};
